import React from "react";
import DiaglogBox from "../DiaglogBox";

const RemarksDailogBox = ({ remarks, open, onCancel }) => {
  return (
    <div>
      <DiaglogBox width={617} open={open} onCancel={onCancel}>
        <div className="pb-5">
          <h4 className="pt-8 pb-4 w-full text-black text-xl font-bold text-center">
            Credit Retirement process not completed
          </h4>
          <hr />
          <p className="text-left font-bold text-[sm px-11 py-3">Admin's Remarks</p>
          <div className="px-11">
            <textarea
              className="border border-gray-300 p-2 focus:outline-none rounded-lg"
              style={{ width: "500px", height: "200px", resize: "none" }}
              readOnly
              value={remarks || ""}
            />
          </div>
        </div>
      </DiaglogBox>
    </div>
  );
};

export default RemarksDailogBox;
